import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import ServicePage from './pages/ServicePage';
import Contact from './pages/Contact';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import Admin from './pages/Admin';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/equine-physiotherapy" element={<ServicePage />} />
            <Route path="/canine-physiotherapy" element={<ServicePage />} />
            <Route path="/canine-hydrotherapy" element={<ServicePage />} />
            <Route path="/cats-small-animals" element={<ServicePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
